import React from 'react';

const fullAlpha = 'A-ZÀ-Üa-zà-ü';

export class RepresentanteLegalPJ extends React.Component {
	constructor() {
		super();
		this.cpf = React.createRef();
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		const { name, value } = e.target;

		const target = {
			name: 'representante_legal',
			value: {
				...this.props.value,
				[name]: value,
			},
		};

		this.props.onChange({ target });
	}

	render() {
		const { nome, cargo, cpf } = this.props.value;

		const onChange = this.onChange;

		return (
			<div>
				<div className="bg-light">
					<h2 className="my-0 text-dark">Representante Legal</h2>
				</div>

				<div className="row mb-3">
					<div className="mb-2 col-lg-12 col-md-12 col-sm-12 col-12">
						<label className="form-label" htmlFor="nome">Nome Completo</label>
						<input className="form-control" id="nome" name="nome" type="text" value={nome} onChange={onChange} required minLength="7" maxLength="60" pattern={`^[${fullAlpha}][${fullAlpha} ]{5,58}[${fullAlpha}]$`} />
					</div>

					<div className="mb-2 col-lg-8 col-md-8 col-sm-12 col-12">
						<label className="form-label" htmlFor="cargo">Cargo</label>
						<input className="form-control" id="cargo" name="cargo" type="text" value={cargo} placeholder="Proprietário, Diretor..." onChange={onChange} required minLength="2" maxLength="60" pattern="^.{2,60}$" />
					</div>

					<div className="mb-2 col-lg-4 col-md-4 col-sm-12 col-12">
						<label className="form-label" htmlFor="cpf">CPF</label>
						<label className="badge badge-pill badge-info">somente números</label>
						<label className="badge badge-pill badge-light">opcional</label>
						<input className="form-control" id="cpf" name="cpf" type="text" defaultValue={cpf !== undefined ? cpf : ''} ref={this.cpf} onChange={onChange} placeholder="somente números" minLength="11" maxLength="11" pattern="^[0-9]{11}$" />
					</div>
				</div>
			</div>
		);
	}
}
